













































































































import {Component} from 'vue-property-decorator';
import GenericDistribution from '@/pages/Pages/Distributions/GenericDistribution.vue'
import SmsTemplate from '@/pages/Pages/Templates/SmsTemplate.vue'
import { MsgTransports } from '@/store/types';
import {SelectWings} from 'wings-ui-components';

Component.registerHooks(['beforeRouteLeave']);

@Component({components: {GenericDistribution, SmsTemplate, SelectWings}})
export default class SmsDistribution extends GenericDistribution {

  transport = MsgTransports.SMS

  beforeRouteLeave(to:any, from:any, next:any) {
    this.beforeLeave(to,from,next)
  }
}
